import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCommonConfig } from "../../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";
import { formatPricewithdecimal } from "../../../../NumberFormat";
import CommonBetHeader from "../../CommonBetHeader";

const Tengah = (props) => {
  const tengahInputRef = useRef(null);
  const tepiInputRef = useRef(null);
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [rowsToShow, setRowsToShow] = useState(10);
  const [values, setValues] = useState([]);
  const [belliValues, setBelliValues] = useState([]);
  const [radioValues, setRadioValues] = useState([]);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [reqData, setReqData] = useState({
    gameId: null,
    gameType: "tengahtepi",
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth",
  });
  const [reqDataMo, setReqDataMo] = useState({
    gameId: null,
    gameType: "tengahtepi",
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth",
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [tengahValue, setTengahValue] = useState("");
  const [tepiValue, setTepiValue] = useState("");
  const radioRefs = useRef([]);
  const belliRefs = useRef([]);

  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "tengahtepi" }));
  }, []);

  useEffect(() => {
    generateDataAngka();
  }, [belliValues, radioValues]);

  const handleInputChange = (e, rowIndex, columnName) => {
    const { name, value } = e.target;
    let minValue = null;
    let maxValue = null;

    if (columnName === "Belli") {
      minValue = betDiscount.showMin / 1000;
      maxValue = betDiscount.showMax / 1000;
      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      if (!regex.test(value)) {
        clearBetValue(rowIndex, value);
      }
      // else if (value < minValue) {
      //   setShowErrorPopup(true);
      //   setErrorMessage("Minimum bet is 1");
      //   clearBetValue(rowIndex, value);
      // } 
      else if (value > maxValue) {
        setShowErrorPopup(true);
        setErrorMessage(props.t("you_have_reached_max_bet_value"));
        clearBetValue(rowIndex, value);
      } else {
        setBelliValues((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else if (columnName === "Radio") {
      const newValue = [...values];
      newValue[rowIndex] = value;
      setValues(newValue);
      setRadioValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleInputBlur = (e, columnName, name) => {
    let { value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange1(e, columnName, name);
  }

  const handleInputChange1 = (e, columnName, name) => {
    let { value } = e.target;
    value = value.replace(',', '.');
    let minValue = null;
    let maxValue = null;

    minValue = betDiscount.showMin / 1000;
    maxValue = betDiscount.showMax / 1000;
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (!regex.test(value)) {
      e.target.value = value.slice(0, -1);
    }
    // else if (value < minValue) {
    //   setShowErrorPopup(true);
    //   setErrorMessage("Minimum bet is 1");
    //   e.target.value = value.slice(0, -1);
    // } 
    else if (value > maxValue) {
      setShowErrorPopup(true);
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      e.target.value = value.slice(0, -1);
    } else {
      if (name === "Tengah") {
        setTengahValue(value);
      } else if (name === "Tepi") {
        setTepiValue(value);
      }
      calculateTotal(value, name);
    }
  };

  const calculateTotal = (value, name) => {
    const betAmount = value * betDiscount.showMultiple;

    // If betAmount is 0, remove the bet from the array
    if (betAmount === 0) {
      setReqDataMo((prevState) => {
        const updatedData = prevState.dataangka.filter((item) => item[0] !== name);

        let totalTengah = 0;
        let totalTepi = 0;

        updatedData.forEach((item) => {
          if (item[0] === "Tengah") {
            if (Math.sign(betDiscount.keitengah) === -1) {
              totalTengah += item[1] + (item[1] * (Math.abs(betDiscount.keitengah) / 100)) - ((item[1] + (item[1] * (Math.abs(betDiscount.keitengah) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalTengah += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "Tepi") {
            if (Math.sign(betDiscount.keitepi) === -1) {
              totalTepi += item[1] + (item[1] * (Math.abs(betDiscount.keitepi) / 100)) - ((item[1] + (item[1] * (Math.abs(betDiscount.keitepi) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalTepi += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          }
        });

        const totalAmount = parseFloat((totalTengah + totalTepi).toFixed(2));
        setTotalAmount(totalAmount);

        return {
          ...prevState,
          dataangka: updatedData,
        };
      });
    } else {
      const resultArray = [name, betAmount, "success"];

      setReqDataMo((prevState) => {
        const updatedData = prevState.dataangka.filter((item) => item[0] !== name);
        const newData = [...updatedData, resultArray];

        let totalTengah = 0;
        let totalTepi = 0;

        newData.forEach((item) => {
          if (item[0] === "Tengah") {
            if (Math.sign(betDiscount.keitengah) === -1) {
              totalTengah += item[1] + (item[1] * (Math.abs(betDiscount.keitengah) / 100)) - ((item[1] + (item[1] * (Math.abs(betDiscount.keitengah) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalTengah += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "Tepi") {
            if (Math.sign(betDiscount.keitepi) === -1) {
              totalTepi += item[1] + (item[1] * (Math.abs(betDiscount.keitepi) / 100)) - ((item[1] + (item[1] * (Math.abs(betDiscount.keitepi) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalTepi += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          }
        });


        const totalAmount = parseFloat((totalTengah + totalTepi).toFixed(2));
        setTotalAmount(totalAmount);

        return {
          ...prevState,
          dataangka: newData,  // Update with new bet data
        };
      });
    }
  };


  const clearBetValue = (rowIndex, value) => {
    if (belliRefs.current[rowIndex]) {
      belliRefs.current[rowIndex].value = "";
    }
  };

  // const validateForm = () => {
  //   let isTable1Valid = false;
  //   let isTable2Valid = false;

  //   for (let i = 0; i < rowsToShow; i++) {
  //     if (radioValues[`tepiTengah-${i}`] && belliValues[`belli-${i}`]) {
  //       if (i < rowsToShow / 2) {
  //         isTable1Valid = true;
  //       } else {
  //         isTable2Valid = true;
  //       }
  //     }
  //   }

  //   if (!isTable1Valid || !isTable2Valid) {
  //     setErrorMessage("Each table must have at least one row selected with a radio button and a beli amount.");
  //     setShowErrorPopup(true);
  //     return false;
  //   }
  //   return true;
  // };

  const generateDataAngka = () => {
    let newDataAngka = Array.from({ length: rowsToShow }, (_, index) => {
      const key = `tepiTengah-${index}`;
      const radioValue = radioValues[key];
      const belliValue = belliValues[`belli-${index}`] * betDiscount.showMultiple;
      const status = radioValue && belliValue ? "success" : null;
      const selectValue = document.querySelector(
        `select[name="tepiTengah-${index}"]`
      )?.value;
      const selectStatus = selectValue && belliValue ? "success" : null;
      return [
        device === "Desktop" ? radioValue : selectValue,
        belliValue || "",
        device === "Desktop" ? status : selectStatus,
      ];
    });
    setReqData((prevState) => ({
      ...prevState,
      gameId: gameId,
      dataangka: newDataAngka,
    }));
  };
  const submitProcess = (event) => {
    // if (device == 'Desktop') {
    if (Array.isArray(reqDataMo.dataangka) && reqDataMo.dataangka.length === 0) {
      setErrorMessage(
        "No bets are placed. Please fill in your bet and betting amount."
      );
      setShowErrorPopup(true);
    } else {
      setShowConfirmationPopup(true);
    }
    // } else {
    // setShowConfirmationPopup(true);
    // }
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  const filteredDataangka = reqData.dataangka.filter(
    (item) => item[0] !== null && item[1] !== "" && item[2] !== null
  );

  // const requestData = { ...reqData, dataangka: (device != 'Desktop' ? reqDataMo.dataangka : filteredDataangka) };
  const requestData = { ...reqData, dataangka: reqDataMo.dataangka };

  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, requestData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      allDataReset();
      // if (device == 'Mobile') {
      //   setTotalAmount(0);
      //   tengahInputRef.current.value = "";
      //   tepiInputRef.current.value = "";
      // }
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  };
  const handleClose = () => {
    setSuccessPopup(false);
    setSubmitRespData([]);
  };

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  const allDataReset = () => {
    setValues([]);
    setBelliValues([]);
    setRadioValues([]);
    setTengahValue("");
    setTepiValue("");
    setReqData({
      gameId: null,
      gameType: "tengahtepi",
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth",
    });
    setReqDataMo({
      gameId: gameId,
      gameType: "tengahtepi",
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth",
    });
    radioRefs.current.forEach((ref) => {
      if (ref) ref.checked = false;
    });
    belliRefs.current.forEach((ref) => {
      if (ref) ref.value = "";
    });
    document
      .querySelectorAll('select[name^="tepiTengah-"]')
      .forEach((select) => {
        select.value = "";
        select.disabled = false;
      });
    tengahInputRef.current.value = "";
    tepiInputRef.current.value = "";
    setTotalAmount(0);
  };
  const rowDataReset = (rowIndex) => {
    if (radioRefs.current[rowIndex * 2]) {
      radioRefs.current[rowIndex * 2].checked = false;
    }
    if (radioRefs.current[rowIndex * 2 + 1]) {
      radioRefs.current[rowIndex * 2 + 1].checked = false;
    }
    const selectElement = document.querySelector(
      `select[name="tepiTengah-${rowIndex}"]`
    );
    if (selectElement) {
      selectElement.value = "";
    }
    if (belliRefs.current[rowIndex]) {
      belliRefs.current[rowIndex].value = "";
    }
    setValues((prevState) => {
      const newState = [...prevState];
      newState[rowIndex] = "";
      return newState;
    });
    setRadioValues((prevState) => {
      const newState = { ...prevState };
      delete newState[`tepiTengah-${rowIndex}`];
      return newState;
    });
    setBelliValues((prevState) => {
      const newState = { ...prevState };
      delete newState[`belli-${rowIndex}`];
      return newState;
    });
  };
  return (
    <div className="maintabcontent-wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="container">
            <div className="tengah-table">

              <CommonBetHeader rowsToShow={null} handleRowsToShowChange={null} bbPayAmount={0} totalBetAmount={totalAmount} gameName="tengahDasar" />
              {/* <div className="buy-data">Buy it x 1000</div> */}
              <div className="edge-data">
                <div className="central">
                  <div className="text">{props.t("middle")}</div>
                  <div>Kei:{betDiscount["keitengah"]}%</div>
                </div>
                <div className="edge">
                  <div className="text">{props.t("side")}</div>
                  <div>Kei:{betDiscount["keitepi"]}%</div>
                </div>

              </div>

              <div className="tengah-input">
                <div className="input-text">
                  <input
                    type="text"
                    name="tengah"
                    value={tengahValue}
                    placeholder="Bet"
                    inputMode="decimal"
                    pattern="[0-9]*[.,]?[0-9]**"
                    ref={tepiInputRef}
                    onChange={(e) =>
                      handleInputChange1(e, "Belli", 'Tengah')
                    }
                    onBlur={(e) =>
                      handleInputBlur(e, "Belli", 'Tengah')
                    }
                  />
                </div>
                <div className="input-text">
                  <input
                    type="text"
                    name="tepi"
                    value={tepiValue}
                    placeholder="Bet"
                    inputMode="decimal"
                    pattern="[0-9]*[.,]?[0-9]**"
                    ref={tengahInputRef}
                    onChange={(e) =>
                      handleInputChange1(e, "Belli", 'Tepi')
                    }
                    onBlur={(e) =>
                      handleInputBlur(e, "Belli", 'Tepi')
                    }
                  />
                </div>
              </div>
            </div>
          </div>



          <div className="last_div">
            <div className="left_div">
              <p>{props.t("tengah_dasar_tengah_text")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={allDataReset}>
                    {props.t('reset')}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={submitProcess}>
                    {props.t('submit')}
                  </button>
                </li>
              </ul>
            </div>
            {showConfirmationPopup && (
              <ConfirmBetDeskonPopup
                onClose={hanldeConfirmationPopupClose}
                submitProcessOk={submitProcessOk}
              />
            )}
            {successPopup && (
              <div className="popup-overlay">
                <BetSuccessPopup
                  response={SubmitRespData}
                  onClose={() => handleClose()}
                />
              </div>
            )}
            {showErrorPopup && (
              <ErrorInnerPopup
                modalTitle={""}
                modalHeader={true}
                onCloseModal={() => setShowErrorPopup(false)}
              >
                <ErrorPopup
                  message={errMessage}
                  onClose={() => setShowErrorPopup(false)}
                />
              </ErrorInnerPopup>
            )}
            {showCancelledPopup && (
              <CancelledBetDeskonPopup
                onClose={() => setShowCanclledPopup(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default withTranslation()(Tengah);
